"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEnterOrSpace = _interopRequireDefault(require("../../../shared/helpers/isEnterOrSpace"));

var _iconCaret = _interopRequireDefault(require("../../../shared/icons/icon-caret.svg"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ExpandableItem = /*#__PURE__*/function (_Component) {
  _inherits(ExpandableItem, _Component);

  var _super = _createSuper(ExpandableItem);

  function ExpandableItem(props) {
    var _this;

    _classCallCheck(this, ExpandableItem);

    _this = _super.call(this, props);
    _this.state = {
      open: false
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ExpandableItem, [{
    key: "toggle",
    value: function toggle() {
      var open = this.state.open;
      this.setState({
        open: !open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dataClient = _this$props.dataClient,
          divider = _this$props.divider,
          topic = _this$props.topic,
          expandable_heading = _this$props.expandable_heading,
          expandable_body = _this$props.expandable_body;
      var open = this.state.open;
      var iconClass = (0, _classnames["default"])({
        'content-page__expandable-list-caret': true,
        'content-page__expandable-list-caret--open': open
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, divider && /*#__PURE__*/_react["default"].createElement("div", {
        className: "content-page__expandable-list-hr"
      }), topic.length > 0 && /*#__PURE__*/_react["default"].createElement("h2", {
        className: "content-page__expandable-list-title"
      }, dataClient.textToMarkdown(topic)), /*#__PURE__*/_react["default"].createElement("div", {
        "aria-expanded": open,
        className: "content-page__expandable-list-item",
        onClick: this.toggle,
        onKeyPress: function onKeyPress(event) {
          return (0, _isEnterOrSpace["default"])(event) && _this2.toggle();
        },
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "content-page__expandable-list-handle"
      }, expandable_heading, /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
        className: iconClass
      })), open && /*#__PURE__*/_react["default"].createElement("div", {
        className: "content-page__expandable-list-body"
      }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
        baseClass: "content-page__expandable-list-body",
        content: expandable_body
      }))));
    }
  }]);

  return ExpandableItem;
}(_react.Component);

ExpandableItem.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  divider: _propTypes["default"].bool.isRequired,
  topic: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  expandable_heading: _propTypes["default"].string.isRequired,
  expandable_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
var _default = ExpandableItem;
exports["default"] = _default;